// Debug utility for enhanced console logging
const isDevelopment = import.meta.env.DEV

export const debug = {
  log: (message: string, ...args: unknown[]) => {
    if (isDevelopment) {
      console.log(`[DEBUG] ${message}`, ...args)
    }
  },

  error: (message: string, ...args: unknown[]) => {
    if (isDevelopment) {
      console.error(`[ERROR] ${message}`, ...args)
    }
  },

  warn: (message: string, ...args: unknown[]) => {
    if (isDevelopment) {
      console.warn(`[WARN] ${message}`, ...args)
    }
  },

  info: (message: string, ...args: unknown[]) => {
    if (isDevelopment) {
      console.info(`[INFO] ${message}`, ...args)
    }
  },

  group: (label: string, fn: () => void) => {
    if (isDevelopment) {
      console.group(`[DEBUG] ${label}`)
      fn()
      console.groupEnd()
    }
  },

  table: (data: unknown) => {
    if (isDevelopment) {
      console.table(data)
    }
  }
}

// Enhanced console for development with better terminal visibility
// Disabled timestamp logging to reduce console noise
// if (isDevelopment) {
//   // Override console methods to add timestamps and ensure terminal visibility
//   const originalLog = console.log;
//   const originalError = console.error;
//   const originalWarn = console.warn;
//   const originalInfo = console.info;

//   console.log = (...args: any[]) => {
//     const timestamp = new Date().toISOString();
//     originalLog(`[${timestamp}] [LOG]`, ...args);
//   };

//   console.error = (...args: any[]) => {
//     const timestamp = new Date().toISOString();
//     originalError(`[${timestamp}] [ERROR]`, ...args);
//   };

//   console.warn = (...args: any[]) => {
//     const timestamp = new Date().toISOString();
//     originalWarn(`[${timestamp}] [WARN]`, ...args);
//   };

//   console.info = (...args: any[]) => {
//     const timestamp = new Date().toISOString();
//     originalInfo(`[${timestamp}] [INFO]`, ...args);
//   };
// }
